import { FETCH_USER_PERMISSIONS_SUCCESS, FETCH_USER_SETTINGS_SUCCESS, UPDATE_SCROLL_STEP } from '../actions/user'
import { IUserPermission } from '../models/portal/permissions'

export type UserProps = {
    permissions: IUserPermission[] | null
    settings: {
        scrollStep: number
    }
}

const initialState: UserProps = {
    permissions: null,
    settings: {
        scrollStep: 20,
    },
}

export const userReducer = (state: UserProps = initialState, action): UserProps => {
    switch (action.type) {
        case FETCH_USER_PERMISSIONS_SUCCESS:
            return {
                ...state,
                permissions: action.payload.userPermissions,
            }

        case FETCH_USER_SETTINGS_SUCCESS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    ...action.payload.userSettings,
                },
            }

        case UPDATE_SCROLL_STEP:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    scrollStep: action.payload.scrollStep,
                },
            }

        default:
            return state
    }
}

export const getUserPermissions = (state: UserProps): UserProps['permissions'] => state.permissions
export const getScrollStep = (state: UserProps): UserProps['settings']['scrollStep'] => state.settings.scrollStep
